/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProjectRoutes_viewer = {
    readonly actualPersonId: string | null;
    readonly project: {
        readonly " $fragmentRefs": FragmentRefs<"SecondaryNavigation_project">;
    } | null;
    readonly projectGroup: {
        readonly " $fragmentRefs": FragmentRefs<"SecondaryNavigation_projectGroup">;
    } | null;
    readonly " $refType": "ProjectRoutes_viewer";
};
export type ProjectRoutes_viewer$data = ProjectRoutes_viewer;
export type ProjectRoutes_viewer$key = {
    readonly " $data"?: ProjectRoutes_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ProjectRoutes_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId",
      "type": "String"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectGroupId",
      "type": "String"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectRoutes_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "projectId"
        }
      ],
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SecondaryNavigation_project"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "projectGroupId"
        }
      ],
      "concreteType": "ProjectGroupType",
      "kind": "LinkedField",
      "name": "projectGroup",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SecondaryNavigation_projectGroup"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = 'd1097cf0492017019ed119ae0ebd4801';
export default node;
